var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1539 14.1873C15.7563 17.1475 11.9577 18.1126 10.1238 15.8901M7.66123 5.88624C8.6778 4.886 10.7347 5.546 10.7347 7.0297M16.3392 5.88624C15.2795 4.8101 13.3555 5.52202 13.2108 7.0297M9.40611 11.5714C11.0464 11.8311 11.4748 8.63905 9.87465 8.40312C8.28069 8.1681 7.78731 11.315 9.40611 11.5714ZM14.5654 11.5754C16.2194 11.3649 15.7298 8.15512 14.1197 8.40397C12.5395 8.64817 12.9451 11.7817 14.5654 11.5754ZM20.752 8.61776V19.8492C20.752 23.7873 16.5038 24.2422 14.9173 21.0132C13.636 23.8192 10.364 23.8192 9.08268 21.0132C7.49622 24.2422 3.24805 23.6104 3.24805 19.8492V8.61776C3.24829 -1.74339 20.7517 -1.74339 20.752 8.61776Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.0e09924f5c58d6355f1fd37068e71186.svg";
export { ForwardRef as ReactComponent };